export default "__VITE_ASSET__C30_rxfa__"